module.exports = "<ng2-slim-loading-bar></ng2-slim-loading-bar>\n<router-outlet>\n    <app-spinner></app-spinner>\n</router-outlet>"